// src/config.js
// const API_BASE_URL = "http://localhost:5000";


const API_BASE_URL = window.__ENV__?.API_URL || "https://api.cityzoom.in/api";

export default API_BASE_URL;

